import { NODE_IMAGE, NODE_PARAGRAPH, render } from "storyblok-rich-text-react-renderer";
import Image from "next/image";
import { RichtextStoryblok } from "@/types/sb-component-types";
import { getDimensionsFromFilename } from "@/lib/storyblok/get-dimensions";
import { cn } from "@/lib/utils";
interface RenderRichtextProps {
  content?: RichtextStoryblok;
  proseSize?: string;
}
export const RenderRichtext = ({
  content,
  proseSize = "lg"
}: RenderRichtextProps) => {
  if (!content) return null;
  return <div className={cn(`prose prose-slate md:prose-${proseSize} prose-a:text-secondary prose-a:no-underline hover:prose-a:underline`)} data-sentry-component="RenderRichtext" data-sentry-source-file="RenderRichtext.tsx">
      {render(content, {
      nodeResolvers: {
        [NODE_PARAGRAPH]: children => {
          if (Array.isArray(children) && children.length === 1) {
            const child = children[0];
            if (child.type === "div") {
              return child;
            }
          }
          if (!children) return <br />;
          return <p className="only:m-0">{children}</p>;
        },
        [NODE_IMAGE]: (children, props) => {
          if (!props.src) return null;
          const dimensions = getDimensionsFromFilename(props.src);
          return <Image alt={props.alt || ""} className="rounded-sm object-cover" height={dimensions?.height ?? 0} src={props.src} style={{
            margin: 0
          }} width={dimensions?.width ?? 0} />;
        }
      }
      // defaultBlokResolver: (name, props) => {
      //   const blok = { ...props, component: name }

      //   return <StoryblokComponent blok={blok} />
      // },
    })}
    </div>;
};